// src/components/common/headers/headerOne.jsx (Black Header)
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useStickyHeader from '../../../hooks/useStickyHeader';

import { useDispatch, useSelector } from 'react-redux';
import {
  fetchUserDataRequest,
  fetchUserProfilePicRequest,
  clearUser
} from '../../../store/user/userSlice';

import { menuList } from '../../../utils/fakeData/menuList';
import MobileMenu from './mobileMenu';
import black_logo from "../../../assets/images/black-logo.png";
import placeholder from '../../../assets/images/placeholder_image.jpg';

// Custom CSS
import './Header.css';



// User profilePic and userName
const UserSection = ({ userData, handleLogout, style }) => {
  if (userData.status === 'loading') {
    return null;
  }

  return userData.email ? (
    <li className="nav-item align-items-center" style={{ display: 'flex', ...style }}>
      <Link className="text-decoration-none" to="/profile">
        <img
          src={userData.profilePicData || placeholder}
          alt="User"
          className="rounded-circle me-2"
          style={{ width: '40px', height: '40px', objectFit: 'cover' }}
        />
        <span className="me-3" style={{ color: "white" }}>
          {(userData.name !== 'User' ? userData.name : userData.email.split('@')[0]) || 'Unauthorized User'}
        </span>
      </Link>
      <button className="btn btn-danger btn-logout" onClick={handleLogout}>
        登出
      </button>
    </li>
  ) : (
    <li className="nav-item align-items-center" style={{ display: 'flex', ...style }}>
      <Link className="default-btn text-decoration-none" to="/login">
        <i className="ri-login-box-line"></i>
        登入
      </Link>
    </li>
  );
};



// Main Header
const HeaderOne = () => {

  useStickyHeader();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  /*---- Redux userData ----*/

  // User data from Redux store
  const userData = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(fetchUserDataRequest());
  }, [dispatch]);

  useEffect(() => {
    if (userData.profilePic) {
      dispatch(fetchUserProfilePicRequest(userData.profilePic));
    }
  }, [userData.profilePic, dispatch]);

  /*---- Redux userData ----*/



  /*---- Logout function ----*/

  const handleLogout = () => {
    localStorage.removeItem('token'); // Remove the token
    dispatch(clearUser());
    navigate('/login'); // Redirect to login page
  };

  /*---- Logout function ----*/



  /*---- Expand Menu ----*/
  const [othersOption, setOtherOption] = useState(false);
  const [menuActive, setMenuActive] = useState(false);
  /*---- Expand Menu ----*/



  /*---- Decide menu items ----*/
  const [filteredMenuList, setFilteredMenuList] = useState(menuList);

  useEffect(()=>{
    if(!userData?.email){
      setFilteredMenuList((prevList) =>
        menuList.filter(m=>m.label !== '帳號管理')
      );
    } else {
      setFilteredMenuList(menuList);
    }
  },[userData?.email]);
  /*---- Decide menu items ----*/



  return (
    <div className="navbar-area style-2">

      {/* Shown when small screen */}
      <MobileMenu 
        menuActive={menuActive} 
        setMenuActive={setMenuActive} 
        menuStyle={`black`} 
        userData={userData}
        handleLogout={handleLogout}
      />
      

      {/* Left & Center when Big Screen, hide when <992px(md) */}
      <div className="desktop-nav style-2">
        <div className="container-fluid">
          <nav className="navbar navbar-expand-md navbar-light">

            {/* Left side: Site Logo */}
            <Link className="navbar-brand me-0" to="/" 
              style={{ height: '80px', width: '230px', display: 'flex', alignItems: 'center' }}
            >
              <img src={black_logo} className="black-logo" alt="logo" />
            </Link>


            {/* Middle: Dropdown Menu & User */}
            <div className="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
              
              {/* Main Dropdown Menu */}
              <ul className="navbar-nav m-auto">
                {filteredMenuList.map(({ id, dropDown, label, path }) => (
                  <li key={id} className="nav-item">
                    <Link to={path} className={`nav-link ${dropDown.length ? 'dropdown-toggle' : ''}`}>
                      {label}
                    </Link>
                    {dropDown.length > 0 && (
                      <ul className="dropdown-menu">
                        {dropDown.map(({ id, path, label }) => (
                          <li key={id} className="nav-item">
                            <Link to={path} className="nav-link">{label}</Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>

              {/* Logged in User Profile */}
              <div className="others-options"
                style={{
                  display: 'flex',
                  minWidth: '200px',
                  justifyContent: 'space-around'
                }}
              >
                <UserSection userData={userData} handleLogout={handleLogout} />
              </div>

            </div>
          </nav>
        </div>
      </div>


      {/* Right Side when Small Screen */}
      <div className="others-option-for-responsive">
        <div className="container">

          {/* Logged in User Profile */}
          <div className="others-options user-logout"
            style={{
              display: 'none',
              minWidth: '200px',
              justifyContent: 'space-around',
              position: 'absolute',
              top: '-60px',
              background: 'transparent',
              right: userData.email ? undefined : 'calc(160px - 8rem)',
              padding: userData.email ? '17px 0px' : '10px 0px',
              marginRight: userData.email ? '10px' : '0px',
            }}
          >
            <UserSection
              userData={userData}
              handleLogout={handleLogout}
              style={{ display: 'flex' }}
            />
          </div>

          {/* Three dot tool menu when Big Screen */}
          {/*
          <div className="dot-menu" onClick={() => setOtherOption(!othersOption)}>
            <div className="inner">
              <div className="circle circle-one"></div>
              <div className="circle circle-two"></div>
              <div className="circle circle-three"></div>
            </div>
          </div>
          */}

          {/* Three line dropdown menu when Big Screen */}
          {/* Menu Content is in MobileMenu */}
          <div className='menu-icon'>
            <i className={`ri-menu-line ${menuActive ? "d-none" : "d-block "}`} onClick={() => setMenuActive(true)}></i>
            <i className={`ri-close-line  ${menuActive ? "d-block " : "d-none"}`} onClick={() => setMenuActive(false)}></i>
          </div>

          {/* Three dot tools */}
          {/*
          <div className={`container ${othersOption ? "active" : ""} `}>
            <div className="option-inner">
              <div className="others-options justify-content-center d-flex align-items-center">
                <ul>
                  <li>
                    <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
                      <i className="ri-search-2-line"></i>
                    </button>
                  </li>
                  <li>
                    <Link className="quote text-decoration-none" to="/contact">
                      <i className="ri-chat-quote-line"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          */}


        </div>
      </div>


    </div>
  );
};

export default HeaderOne;


